import React from 'react';
import useAuth from '../../../../hooks/useAuth';
import PermissionDenied from '../PermissionDenied/PermissionDenied';

const RequiredProductList = ({ children }) => {

    const { productList } = useAuth();
  
    if(!productList) { 
        return <PermissionDenied /> 
    }
    
    return children;
};

export default RequiredProductList;